import React, { Component } from "react";
import Receipt from "./Receipt";
import { compose } from "recompose";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { container } from "../../store/Containers/cntCommon";
import Breadcrumbs from "components/Common/Breadcrumb";

import { API_WEB_URLS } from "constants/constAPI";
import { Fn_FillListData } from "store/functions";



class PrintReceiptMerge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Details: [
        {
          company: "Momai Gudka",
          number: "9762190890",
          logoname: "Momai Communication",
          address:
            "Shop No. 17, Prerna Complex, Dhapoda Rd, Val Village, Bhiwandi",
          date: "01-01-2025",
          receiptno: "D84336",
          name: "ShantiDevi",
          sender: "7754935988",
          receiver: "",
          accountno: "48468100007150",
          ifsc: "SBIN0000659",
          bankname: "BANK OF BARODA",
          amount: "8000",
          transactioncode: "213241008103044",
        },
      ],
      arr:{}
    };
    this.obj = this;
    this.formTitle = "Print Receipt";
    this.breadCrumbTitle = "Print Receipt";
    this.breadCrumbItem = " " + this.formTitle;
    this.back = this.back.bind(this);
    this.receiptRef = React.createRef();
  }

  back() {
    this.props.history.push("/pendingcharges");
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const selectedIds = this.props.location.state?.arr || [];
    this.setState({arr:selectedIds});
  
  }

  render() {
    
  
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            {/* <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            /> */}
            <Row>
              <Col sm="3" className="mb-3">
                <Button
                  type="button"
                  color="primary"
                  onClick={this.back}
                  className="mr-1 waves-effect waves-light"
                >
                  Reset
                </Button>
                <Button
                  type="button"
                  color="success"
                  onClick={() => this.receiptRef.current.printReceipt()}
                  className="mr-1 waves-effect waves-light"
                >
                  Print
                </Button>
              </Col>

              <Receipt
                ref={this.receiptRef}
                company={this.state.Details[0].company}
                number={this.state.Details[0].number}
                logoname={this.state.Details[0].logoname}
                address={this.state.Details[0].address}
                date={this.state.arr.date}
                receiptno={this.state.arr.receiptno}
                name={this.state.arr.name}
                sender={this.state.arr.sender}
                receiver={''}
                accountno={this.state.arr.accountno}
                ifsc={''}
                bankname={this.state.arr.bankname}
                amount={this.state.arr.amount}
                transactioncode={this.state.arr.transactioncode}
              />
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(container)(PrintReceiptMerge);
